import LazyLoadingTransportStoreBase, {
  EventBasedTransport,
} from '@codefluegel/lazy-loading-key-value-store';
import { computed, makeObservable } from 'mobx';
import { MaexchenRedeemProducts } from '../types/transport';

export default class RedeemProductStore extends LazyLoadingTransportStoreBase<MaexchenRedeemProducts> {
  constructor(transport: EventBasedTransport<MaexchenRedeemProducts>) {
    super(transport);
    makeObservable(this, {
      filteredEntries: computed,
    });
  }

  get filteredEntries(): typeof this.entriesArray {
    return this.entriesArray.filter(
      entry =>
        entry.Verfuegbar &&
        new Date(entry.GueltigVon).getTime() < Date.now() &&
        new Date(entry.GueltigBis).getTime() > Date.now(),
    );
  }
}
